import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { ConcreteScenarioService, FunctionalScenarioService, LogicalScenarioService } from '@shared/openapi/business';
import { authGuard } from '@core/guards/auth.guard';

export const scenariosManageRoutes: Routes = [
  {
    path: 'manage',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@features/scenarios-manage/pages/scenarios-manage.component').then((c) => c.ScenariosManageComponent),
    children: [
      {
        path: 'dataset/:id',
        loadComponent: () =>
          import('@features/scenarios-manage/pages/dataset-manage/dataset-manage.component').then(
            (c) => c.DatasetManageComponent,
          ),
      },
      {
        path: 'functional/:id',
        loadComponent: () =>
          import('@features/scenarios-manage/pages/functional-scenario/functional-scenario.component').then(
            (c) => c.FunctionalScenarioComponent,
          ),
        resolve: {
          scenario: (route: ActivatedRouteSnapshot) =>
            inject(FunctionalScenarioService).getFunctionalScenarioById(route.params['id']),
        },
      },
      {
        path: 'logical/:id',
        loadComponent: () =>
          import('@features/scenarios-manage/pages/logical-scenario/logical-scenario.component').then(
            (c) => c.LogicalScenarioComponent,
          ),
        resolve: {
          scenario: (route: ActivatedRouteSnapshot) =>
            inject(LogicalScenarioService).getLogicalScenarioById(route.params['id']),
        },
      },
      {
        path: 'concrete/:id',
        loadComponent: () =>
          import('@features/scenarios-manage/pages/concrete-scenario/concrete-scenario.component').then(
            (c) => c.ConcreteScenarioComponent,
          ),
        resolve: {
          scenario: (route: ActivatedRouteSnapshot) =>
            inject(ConcreteScenarioService).getConcreteScenarioById(route.params['id']),
        },
      },
    ],
  },
];
